import { ConcreteEncodable } from "./ConcreteEncodable";

import { ProfileUpdateRequestImplEncoder } from "../../encoder/ProfileUpdateRequestImplEncoder";

import * as CubiqTS from "../../index";
import { ProfileUpdateRequest } from "../ProfileUpdateRequest";

export class ProfileUpdateRequestImpl extends ConcreteEncodable implements ProfileUpdateRequest {
  public static enType: string = "com.bcdfx.model.event.ProfileUpdateRequestImpl";

  /*FID=1*/
  public settings: Array<CubiqTS.ProfileSetting> | null = null;
  /*FID=2*/
  public defaultPositionBookId: CubiqTS.Long | null = null;
  /*FID=3*/
  public emailAddress: string;
  /*FID=4*/
  public smsNumber: string;
  /*FID=5*/
  public sendEmailMyOrdEnteredFg: boolean;
  /*FID=6*/
  public sendSMSMyOrdEnteredFg: boolean;
  /*FID=7*/
  public sendEmailMyOrdFillFg: boolean;
  /*FID=8*/
  public sendSMSMyOrdFillFg: boolean;
  /*FID=9*/
  public sendEmailMyOrdExpiryFg: boolean;
  /*FID=10*/
  public sendSMSMyOrdExpiryFg: boolean;
  /*FID=11*/
  public sendEmailAnyOrderIFillFg: boolean;
  /*FID=12*/
  public sendSMSAnyOrderIFillFg: boolean;
  /*FID=13*/
  public updateUserPreferences: boolean;
  /*FID=14*/
  public deltaRequestFg: boolean;
  /*FID=15*/
  public sendEmailMyOrdModifyFg: boolean;
  /*FID=16*/
  public sendSMSMyOrdModifyFg: boolean;
  /*FID=17*/
  public sendEmailMyOrdCancelFg: boolean;
  /*FID=18*/
  public sendSMSMyOrdCancelFg: boolean;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ProfileUpdateRequestImplEncoder.Instance;
    this.setEncodableType(ProfileUpdateRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "ProfileUpdateRequestImpl[" +
      "settings=" +
      this.settings +
      "defaultPositionBookId=" +
      this.defaultPositionBookId +
      "emailAddress=" +
      this.emailAddress +
      "smsNumber=" +
      this.smsNumber +
      "sendEmailMyOrdEnteredFg=" +
      this.sendEmailMyOrdEnteredFg +
      "sendSMSMyOrdEnteredFg=" +
      this.sendSMSMyOrdEnteredFg +
      "sendEmailMyOrdFillFg=" +
      this.sendEmailMyOrdFillFg +
      "sendSMSMyOrdFillFg=" +
      this.sendSMSMyOrdFillFg +
      "sendEmailMyOrdExpiryFg=" +
      this.sendEmailMyOrdExpiryFg +
      "sendSMSMyOrdExpiryFg=" +
      this.sendSMSMyOrdExpiryFg +
      "sendEmailAnyOrderIFillFg=" +
      this.sendEmailAnyOrderIFillFg +
      "sendSMSAnyOrderIFillFg=" +
      this.sendSMSAnyOrderIFillFg +
      "updateUserPreferences=" +
      this.updateUserPreferences +
      "deltaRequestFg=" +
      this.deltaRequestFg +
      "sendEmailMyOrdModifyFg=" +
      this.sendEmailMyOrdModifyFg +
      "sendSMSMyOrdModifyFg=" +
      this.sendSMSMyOrdModifyFg +
      "sendEmailMyOrdCancelFg=" +
      this.sendEmailMyOrdCancelFg +
      "sendSMSMyOrdCancelFg=" +
      this.sendSMSMyOrdCancelFg +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
